import Axios from "axios";
export default {
    actions: {
        async sendDataSheet(context, body) {
            return await Axios.post('https://sheetdb.io/api/v1/ubrxjdnlthmrp', body)
            
        },
    }
}